import React from "react";
const LinkButton =  React.forwardRef((props, ref) => {
  const { title,
    handleClick,
    customClass,
    disabled = false,
    height,
    isModuleScreen,
    } = props;

  const linkButton = {
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    fontSize: '12px',
    fontWeight: 'bold',
    color: disabled ?'#949494':'rgb(32, 54, 98)',
    paddingLeft: '0px',
    paddingRight: '0px',
    height: height,
    cursor: disabled?'default':'pointer',
  };
  return (
    <button
     // title={title}
      style={linkButton}
      variant="light"
      disabled={disabled}
      onClick={handleClick}
      height={height}
      ref={ref}
    >
      {title}
    </button>
  );
});

export default LinkButton;
